
.speedbump {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  top: 0;
  left: 0;
  animation: speedbumpIn 250ms linear forwards;

  &__overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,.7);
  }

  &__inner {
      position: absolute;
      width: 90%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: 750px;
      background: #fff;
      padding: 20px 20px 10px 20px;
      overflow-Y: auto;
      max-height: 100vh;
      border-radius: 5px;
  }

  &__message {
    padding: 0 0 30px 0;
    text-align: center;
  }

  &__actions {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;

    a {
      margin-right: 20px;
      margin-bottom: 10px;
      max-width: 117px;
      width: 100%;
      border-radius: 5px;
      font-weight: 500;
    }

    .btn.btn-secondary {
      &:hover, &:focus {
        transform: translateY(-1px);
      }
    }

    .btn.btn-tertiary {
      border: 2px solid $secondary;

      &:hover, &:focus {
        background: $primary;
        color: #FFF;
        text-decoration: none;
        border: 2px solid $primary;
      }
    }
  }
}

@keyframes speedbumpIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
